import { render, staticRenderFns } from "./PrePrimaryMarksheetAnnual2.vue?vue&type=template&id=63b1e193&scoped=true&"
import script from "./PrePrimaryMarksheetAnnual2.vue?vue&type=script&lang=js&"
export * from "./PrePrimaryMarksheetAnnual2.vue?vue&type=script&lang=js&"
import style0 from "./PrePrimaryMarksheetAnnual2.vue?vue&type=style&index=0&id=63b1e193&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b1e193",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSimpleTable,VSnackbar,VSpacer})
